import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";

interface Props {
  baseId: string;
  isEditMode: boolean;
  onClose: () => void;
}

export function WorkspaceDialogTitle(props: Props) {
  return (
    <DialogTitle
      id={`${props.baseId}-dialog-title`}
      variant="h3"
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20px",
      }}
    >
      {props.isEditMode ? "Edit Project Details" : "Create Project"}
      <IconButton
        data-testid="workspace-dialog-close-btn"
        aria-label="close"
        onClick={props.onClose}
        size="small"
        edge="end"
        sx={{ color: (theme) => theme.palette.grey[500] }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
}
